import Component from './Component';

class FluxStep extends Component {
  view() {
    return document.getElementById('etapa-aprovacao')
      .innerHTML
      .replace(/&gt;/g, '>')
      .replace(/&lt;/g, '<');
  }
}

export default FluxStep;
